import { createSlice } from "@reduxjs/toolkit";
import { IBusinessGeneral } from "../interfaces/IBusinessGeneral";

const initialState: IBusinessGeneral = {
  orderTypes: [],
  receivableLimits: [],
  сonsignmentPeriods: [],
  paymentTermConditions: [],
  paymentTermConfigTypes: [],
};

const businessGeneralSlice = createSlice({
  name: "businessGeneral",
  initialState,
  reducers: {
    initBusinessGeneral: (state, { payload }: { payload: any }) => {
      const { orderTypes, receivableLimits, сonsignmentPeriods, paymentTermConditions, paymentTermConfigTypes } = payload;
      state.orderTypes = orderTypes;
      state.receivableLimits = receivableLimits;
      state.сonsignmentPeriods = сonsignmentPeriods;
      state.paymentTermConditions = paymentTermConditions;
      state.paymentTermConfigTypes = paymentTermConfigTypes;
      return state;
    },
  },
});

export const businessGeneralReducer = businessGeneralSlice.reducer;

export const { initBusinessGeneral } = businessGeneralSlice.actions;
